module.exports = __webpack_public_path__ + "static/media/login-bg.500a0b8a.png";